import { createFileRoute } from "@tanstack/react-router";
import { OrgDimensionSettings } from "@/components/org-dimension-settings";

// US-067 — Admin Settings: Departments master data. Thin route delegating to
// the shared OrgDimensionSettings screen (Locations shares the same component).

export const Route = createFileRoute("/settings/departments")({
  head: () => ({
    meta: [
      { title: "Departments — ProcureFlow" },
      { name: "description", content: "Manage the departments available across the workspace." },
    ],
  }),
  component: DepartmentsPage,
});

function DepartmentsPage() {
  return <OrgDimensionSettings resource="departments" title="Departments" singular="Department" />;
}
